// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import metaInfo from 'vue-meta-info';

import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import VueClipboard  from 'vue-clipboard2'

Vue.use(VueClipboard)

//Vue.use(Waterfall)
//Vue.use(WaterfallSlot)
Vue.component('Waterfall', Waterfall)
Vue.component('WaterfallSlot', WaterfallSlot)

Vue.use(ElementUI);
Vue.use(metaInfo);

import store from './store'
import Vuex from 'vuex'
Vue.use(Vuex) 

import login from './config/vue/login.vue';

Vue.component('login', login)
import footer from './config/vue/footer.vue';

Vue.component('FOOTER', footer)

Vue.config.productionTip = false;

import axios from 'axios';

Vue.prototype.$axios = axios
//Base64.encode(linkpar)
//Base64.decode(linkpar)
//
//router.afterEach((to,from,next) => {
//window.scrollTo(0,0);
//document.documentElement.scrollTop = document.body.scrollTop = 0;
//})







/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js